import _ from 'lodash';
import { TypeEnum } from 'Common/Constants/Enumeration/UpdateOpenOrderEnum';
import { UpdateOpenOrdersEnum } from 'Common/FieldEnum';
import {
  TypeOptionEnum,
  UpdateOpenOrderTypeEnum,
  OrderTypeEnum
} from 'Common/Constants/Enumeration/UpdateOpenOrderEnum';

export const getSaveObject = (values, filteredData) => {
  const saveObj = {
    DeliveryDT: values.DeliveryDT,
    SiteGroupId:
      values.TypeOptions === TypeEnum.OpenOrders ? values.SiteGroup : null,
    WarehouseKitchenId:
      values.TypeOptions === TypeEnum.OpenReceipts
        ? values.WarehouseKitchen
        : values.TypeOptions === TypeEnum.OpenReceiptsKO
          ? values.Kitchen
          : null,
    UpdateOpenOrderType:
      values.TypeOptions === TypeEnum.OpenOrders
        ? UpdateOpenOrderTypeEnum.Order
        : UpdateOpenOrderTypeEnum.Receipt,
    UpdateOpenOrderOperationType:
      values[UpdateOpenOrdersEnum.AddItemListData] &&
      values[UpdateOpenOrdersEnum.RemoveItemListData]
        ? TypeOptionEnum.Both
        : values[UpdateOpenOrdersEnum.AddItemListData]
          ? TypeOptionEnum.ItemToAdd
          : TypeOptionEnum.ItemToRemove,
    AddItemId: values[UpdateOpenOrdersEnum.AddItemListData],
    RemoveItemId: values[UpdateOpenOrdersEnum.RemoveItemListData],
    UpdateOpenOrderGridItemCollection: [],
    OrderType: values.TypeOptions === TypeEnum.OpenOrders
      ? OrderTypeEnum.OpenOrder
      : values.TypeOptions === TypeEnum.OpenReceipts
        ? OrderTypeEnum.OpenReceiptWO
        : OrderTypeEnum.OpenReceiptKO
  };
  saveObj.UpdateOpenOrderGridItemCollection = _.map(filteredData, item => {
    return {
      Selected: item.Selected,
      SiteId: item.SiteId,
      SiteDescription: item.SiteDescription,
      OrderNumber: item.OrderNumber,
      RemoveQtyPrimary:
        item.AddQtyPrimary || item.AddQtySecondary ? 0 : item.RemoveQtyPrimary,
      RemoveQtySecondary:
        item.AddQtyPrimary || item.AddQtySecondary
          ? 0
          : item.RemoveQtySecondary,
      AddQtyPrimary: +item.AddQtyPrimary,
      AddQtySecondary: +item.AddQtySecondary,
      UserHasAccessToSite: item.UserHasAccessToSite,
      SiteHasAccessToAddItem: item.SiteHasAccessToAddItem,
      TransactionId: item.TransactionId,
      IsEditable: item.IsEditable,
    };
  });

  return saveObj;
};

export const getPriSecInDecimalFormat = (
  primaryQty,
  secondaryQty,
  qtyPerUnit
) => {
  const secPerUnit = secondaryQty ? Number(secondaryQty) / qtyPerUnit : 0;
  return !primaryQty && !secPerUnit
    ? 0
    : Number(Number(primaryQty) + Number(secPerUnit)).toFixed(8);
};

export const getPriSecDetail = (
  totalRemaining,
  qtyPerUnit,
  priUnit,
  secUnit
) => {
  const priQty = getDecimalToPrimary(totalRemaining);
  const secQty = getDecimalToSecondary(totalRemaining, qtyPerUnit);
  return `${priQty} ${priUnit} ${secQty} ${secUnit}`;
};

const getDecimalToPrimary = totalRemaining => {
  return totalRemaining
    ? Math.floor(Number(totalRemaining))
    : Math.ceil(Number(totalRemaining));
};

const getDecimalToSecondary = (totalRemaining, qtyPerUnit) => {
  const secPerUnit =
    Number(totalRemaining) - getDecimalToPrimary(totalRemaining);
  return Number(secPerUnit * qtyPerUnit).toFixed(2);
};

export const getSiteGroupOptionsData = siteGroupData => {
  return (siteGroupData && siteGroupData.length
    ? [{ value: 0, key: -1, text: 'ALL' }]
    : []
  ).concat(
    siteGroupData
      ? siteGroupData.map((site, i) => ({
          value: site.Id,
          key: site.Id,
          text: `${site.Description}`,
        }))
      : []
  );
};



// WEBPACK FOOTER //
// ./src/pages/utilities/helper/updateOpenOrders.js